import { render } from "./ChangesSaved.vue?vue&type=template&id=52e8f2e4"
import script from "./ChangesSaved.vue?vue&type=script&lang=js"
export * from "./ChangesSaved.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__